import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  ctnRoot: {
    display: "flex",
    flexDirection: "column",
    // zIndex: 9999,
    [theme.breakpoints.up("sm")]: {
      margin: "40px auto"
    },
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "32px",
      "& > div": {
        "& > span": {
          fontSize: "26px",
          fontWeight: 800
        }
      }
    }
  },
  titleText: {
    [theme.breakpoints.down("sm")]: {
      "& > span": {
        fontSize: "24px !important",
        marginTop: -4
      }
    },
    [theme.breakpoints.up("sm")]: {
      "& > span": {
        fontSize: "24px !important",
        paddingTop: 4,
        marginRight: 28
      }
    },

  },
  rootMg: {
    [theme.breakpoints.up("sm")]: {
      marginTop: "10px",
      marginBottom: "34px",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center"
    },
    [theme.breakpoints.up("xl")]: {
      marginTop: 60,
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: -42,
      marginTop: 20,
    }
  },
  ctnTitle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    "& > span": {
      textAlign: "center",
      fontSize: "32px",
      fontWeight: "800"
    },
  },
  mgLeftLanding: {},
  ctnLogo: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    paddingTop: "10px",
    "& > img": {
      width: "120px",
      objectFit: "contain"
    },
    "& > #sindo-icn": {
      [theme.breakpoints.up("sm")]: {
        width: 120
      },
      [theme.breakpoints.down("sm")]: {
        display: "none"
      },
    },
    [theme.breakpoints.up("sm")]: {
      "& > $mgLeftLanding": {
        marginLeft: "32px"
      }
    },
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      justifyContent: "space-between",
      maxWidth: "75%",
      margin: "auto",
      "& > img": {
        width: "43%",
        marginBottom: 16
      }
    }
  },
  logoMg: {
    [theme.breakpoints.up("sm")]: {
      paddingTop: "12px",
      "& > img": {
        width: "105px",
        objectFit: "contain"
      },
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: "12px",
    }
  },
  mrginLeftPhoto: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: "20px",
    }
  }
}));
